import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { BetslipError } from '../../../errors/betslip-error';

export interface IExtendedMessage {
    title: string;
    message: string;
    callback?: Function;
}

export abstract class MessageFormatter<TError extends BetslipError> {
    abstract canHandle(error: BetslipError): boolean;

    abstract format(error: TError): Observable<string | IExtendedMessage | null>;
}

export function isExtendedMessage(message: string | IExtendedMessage | null): message is IExtendedMessage & boolean {
    return !!message && !(typeof message === 'string');
}

export function isSimpleMessage(message: string | IExtendedMessage | null): message is string {
    return !!message && typeof message === 'string';
}

export const MESSAGE_FORMATTER_INJECTION_TOKEN = new InjectionToken('MESSAGE_FORMATTER_INJECTION_TOKEN');
